var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWindow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#417EFF",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "nonzero",
  d: "M3 5v14h18V5zm0-2h18a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 9h19v2H2z"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 5,
  cy: 7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 7,
  r: 1
}), /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 7,
  r: 1
}))));
export default SvgWindow;